import { render } from "./AnnaSettings.vue?vue&type=template&id=56890b5f&scoped=true"
import script from "./AnnaSettings.vue?vue&type=script&lang=js"
export * from "./AnnaSettings.vue?vue&type=script&lang=js"

import "./AnnaSettings.vue?vue&type=style&index=0&id=56890b5f&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56890b5f"]])

export default __exports__